// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

export default styled<any, Theme>('ul')`
  background-color: ${props => props.theme.languageSelector.backgroundColor};
  list-style: none;
  border-radius: 0 0 ${props => props.theme.languageSelector.borderRadius} ${props => props.theme.languageSelector.borderRadius};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  padding: .5rem 0 .5rem 0;
  margin-top: 0;
`;
